import { ApiHandler, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { getPromotionMessages } from "@store/Services/PromotionMessagesService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { PromotionMessagesCollectionModel } from "@store/Types/ApiModels";

type HandlerType = ApiHandler<{}, PromotionMessagesCollectionModel, StoreHandlerProps>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPromotionMessages();
};

export const DispatchCompleteLoadPromotionMessages: HandlerType = props => {
    props.dispatch({
        type: "Custom/Cart/CompleteLoadPromotionMessages",
        collection: props.apiResult,
    });
};

export const chain = [RequestDataFromApi, DispatchCompleteLoadPromotionMessages];

const loadPromotionMessages = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadPromotionMessages");
export default loadPromotionMessages;
